const index_splide_elm = document.querySelector('.index_splide')
if(index_splide_elm){
  const speed = Number(index_splide_elm.dataset.speed)
   const interval = Number(index_splide_elm.dataset.interval) 
  const index_splide = new Splide( index_splide_elm, {
  type   : 'loop',
  pagination:false,
  autoplay: true,
  pauseOnHover: false,
  interval :interval ,
  speed    : speed
});
 index_splide.mount();
}

// faq script
      const headers = document.querySelectorAll('.accordion-header');
      const accordion = document.querySelector('.accordion');
      const openFirst = accordion?.dataset.openFirst === 'true';

      headers.forEach((header, index) => {
          header.addEventListener('click', () => {
              const content = header.nextElementSibling;

              // Close all other content
              document.querySelectorAll('.accordion-content').forEach(otherContent => {
                  if (otherContent !== content) {
                      otherContent.style.maxHeight = null;
                      otherContent.classList.remove('show');
                      otherContent.previousElementSibling.classList.remove('active');
                  }
              });

              // Toggle current content
              if (content.classList.contains('show')) {
                  content.style.maxHeight = null;
                  content.classList.remove('show');
                  header.classList.remove('active');
              } else {
                  content.style.maxHeight = content.scrollHeight + 'px';
                  content.classList.add('show');
                  header.classList.add('active');
              }
          });

          // Automatically open the first item if setting is enabled
          if (openFirst && index === 0) {
              const content = header.nextElementSibling;
              content.style.maxHeight = content.scrollHeight + 'px';
              content.classList.add('show');
              header.classList.add('active');
          }
      });

      // Ensure maxHeight updates correctly when resizing
      window.addEventListener('resize', () => {
          document.querySelectorAll('.accordion-content.show').forEach(content => {
              content.style.maxHeight = content.scrollHeight + 'px';
          });
      });


initSplideCarousels()


  let mainImagesHtml = "";
  let thumbnailsHtml = "";

setTimeout(() => {


  let strapDesingSelectedOption = document.querySelector('#strap-design-select');
  let selectedVariantWithStrapValue = '';

  window.addEventListener('strap-result-ready', (e) => {
    selectedVariantWithStrapValue = e.detail.result;
  });

  function updateFromSelectedImage() {
    const selectedImg = document.querySelector('.strap-images .splide__slide img.selected');
    if (!selectedImg) return;

    const currentValue = selectedImg.alt;

    let parts = selectedVariantWithStrapValue.split(' / ');
    parts[parts.length - 1] = currentValue;
    selectedVariantWithStrapValue = parts.join(' / ');

    getAndSetSlider(selectedVariantWithStrapValue)
  
  }

 
  strapDesingSelectedOption?.addEventListener('change', updateFromSelectedImage);

  const strapImages = document.querySelector('.strap-images');
  if (strapImages) {
    const observer = new MutationObserver(() => {
      updateFromSelectedImage();
      initSplideCarousels()
    });

    observer.observe(strapImages, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });
  }

  
});



















